import { createSelector } from '@reduxjs/toolkit'
import { CheckoutAppSelector, useAppSelector } from '..'
import { ProcessingState } from './reducer'

/* selectors */
export const processingSelector: CheckoutAppSelector<ProcessingState> = (state) => state.processing

export const displayProcessingModalSelector: CheckoutAppSelector<boolean> = createSelector(processingSelector, (state) => state.displayProcessingModal)

/* hook */
export const useProcessing = (): ProcessingState => useAppSelector(processingSelector)

export const useDisplayProcessingModal = (): boolean => useAppSelector(displayProcessingModalSelector)
